import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as Prohibit } from "../../images/Prohibit.svg";
import styles from "./YuJaTooltip.module.css";
import {findFirstOverflowParent, generateUUID} from "../../utils/helpers";
import useWindowDimensions from "../../hooks/useWindowDimensions";


export const YuJaTooltip = ({
                                text,
                                placement="top",
                                children,
                                tooltipStyle={},
                                visibleInTouchableDevice=false,
                                prohibit=false,
                                disabled=false,
                                offsetX=0,
                                offsetY=0,
                                ...props
}) => {
    const windowDimensions = useWindowDimensions();
    const placementVarRef = useRef(placement);
    const [isTouchAble, setIsTouchAble] = useState(
        window.navigator.maxTouchPoints > 0
        && window.matchMedia('(pointer: coarse)').matches
    );
    const [isOpen, setIsOpen] = useState(false);
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [randomId, ] = useState(() => generateUUID());

    // useEffect(() => {
    //     //adjust position only when tooltip is visible
    //     if (maskVisible) {
    //         resetToolTipPosition();
    //         resetTrianglePosition();
    //     } else {
    //         tooltipRef.current.style.top = '0px';
    //         tooltipRef.current.style.left = '0px';
    //         tooltipTriangleRef.current.style.top = '0px';
    //         tooltipTriangleRef.current.style.left = '0px';
    //     }
    // }, [windowDimensions, toolTrigger?.current?.getBoundingClientRect()]);

    useEffect(() => {
        setIsTouchAble(window.navigator.maxTouchPoints > 0 && window.matchMedia('(pointer: coarse)').matches);
    }, [window.navigator.maxTouchPoints]);



    const resetToolTipPosition = () => {
        //only left and top can be used as anchor, all those variables are just for the current window, it doesn't count the scroll offset
        let tooltipTriangle = document.querySelector(`[data-yuja-tooltip-trigger-id='${randomId}']`);
        let tooltipBox = document.querySelector(`[data-yuja-tooltip-box-id='${randomId}']`);
        const {width: windowWidth, height: windowHeight} = windowDimensions;
        const {width, height, top, left} = tooltipTriangle.getBoundingClientRect();
        const {width: toolTipWidth, height: tooltipHeight} = tooltipBox.getBoundingClientRect();

        tooltipBox.style.top = null;
        tooltipBox.style.bottom = null;
        tooltipBox.style.left = null;
        tooltipBox.style.right = null;
        let adjustedTop = 0;
        let adjustedLeft = 0;
        placementVarRef.current = placement;
        if (placement === "right") {
            adjustedTop = top - (tooltipHeight / 2 - height / 2);
            adjustedLeft = left + width + 10 + offsetX;
            if (adjustedLeft + toolTipWidth > windowWidth) {//not enough place at right
                adjustedLeft = left - toolTipWidth - 10 - offsetX;
                placementVarRef.current = "left";
            }
        } else if (placement === "left") {
            adjustedTop = top - (tooltipHeight / 2 - height / 2);
            adjustedLeft = left - toolTipWidth - 10 - offsetX;
            if (adjustedLeft < 0) {//not enough place at left
                placementVarRef.current = "right";
                adjustedLeft = left + width + 10 + offsetX;
            }
        } else if (placement === "top") {//not enough place at top
            adjustedTop = top - tooltipHeight - 10 - offsetY;
            adjustedLeft = left - (toolTipWidth / 2 - width / 2);
            if (adjustedTop < 0) {
                placementVarRef.current = "bottom";
                adjustedTop = top + height + 10 + offsetY;
            }
        } else if (placement === "bottom") {//not enough place at bottom
            adjustedTop = top + height + 10 + offsetY;
            adjustedLeft = left - (toolTipWidth / 2 - width / 2);
            if (adjustedTop + tooltipHeight > windowHeight) {
                placementVarRef.current = "top";
                adjustedTop = top - tooltipHeight - 10 - offsetY;
            }
        }
        if (adjustedLeft < 0) {
            adjustedLeft = 10;
        } else if (adjustedLeft + toolTipWidth > windowWidth) {
            adjustedLeft = windowWidth - toolTipWidth - 10;
        } else if (adjustedTop < 0) {
            adjustedTop = 10;
        } else if (adjustedTop + tooltipHeight > windowHeight) {
            adjustedTop = windowHeight - tooltipHeight - 10;
        }

        tooltipBox.style.transform = `translate(${Math.round(adjustedLeft + window.scrollX)}px, ${Math.round(adjustedTop + window.scrollY)}px)`;
    }

    const onMouseEnter = (e, callbackF) => {
        if (callbackF) {
            callbackF(e);
        }

        setIsOpen(true);

    }

    const onMouseLeave = (e, callbackF) => {
       if (callbackF) {
           callbackF(e);
       }
       setIsOpen(false);
    }

    const resetTrianglePosition = () => {
        //only left and top can be used as anchor, all those variables are just for the current window, it doesn't count the scroll offset
        const {width: windowWidth, height: windowHeight} = windowDimensions;
        let toolTrigger = document.querySelector(`[data-yuja-tooltip-trigger-id='${randomId}']`)
        const {width, height, top, left } = toolTrigger.getBoundingClientRect();
        let adjustedTop = 0;
        let adjustedLeft = 0;
        if ( placementVarRef.current === "right") {
            adjustedLeft = left + width + offsetX;
            adjustedTop = top + height / 2;
        } else if (placementVarRef.current === "left") {
            adjustedLeft = left - 10 - offsetX;
            adjustedTop = top + height / 2;
        } else if (placementVarRef.current === "top") {//not enough place at top
            adjustedLeft = left + width / 2;
            adjustedTop = top - 10 - offsetY;
        } else if (placementVarRef.current === "bottom") {//not enough place at bottom
            adjustedLeft = left + width / 2;
            adjustedTop = top + height + offsetY;
        }


        if (adjustedLeft < 0) {
            adjustedLeft = 10;
        } else if (adjustedLeft > windowWidth) {
            adjustedLeft = windowWidth- 10;
        } else if (adjustedTop < 0) {
            adjustedTop = 10;
        } else if (adjustedTop > windowHeight) {
            adjustedTop = windowHeight - 10;
        }

        let triangle = document.querySelector(`[data-yuja-tooltip-triangle-id='${randomId}']`);

        triangle.style.transform = `translate(${Math.round(adjustedLeft + window.scrollX)}px, ${Math.round(adjustedTop + window.scrollY)}px)`;
    }


    function isVisible (parent, child) {
        let {top: childTop, height: childHeight} = child.getBoundingClientRect();
        let {top: parentTop, height: parentHeight} = parent.getBoundingClientRect();

        return !(childTop + childHeight < parentTop || childTop > parentTop + parentHeight);

    }


    const setPosition = () => {
        let tooltipBox = document.querySelector(`[data-yuja-tooltip-box-id='${randomId}']`);
        let tooltipTriangle = document.querySelector(`[data-yuja-tooltip-triangle-id='${randomId}']`);
        if(!tooltipTriangle || !tooltipBox) {
            return;
        }

        resetTrianglePosition();
        resetToolTipPosition();

        let toolTrigger = document.querySelector(`[data-yuja-tooltip-trigger-id='${randomId}']`)
        let parent = findFirstOverflowParent(toolTrigger);
        if (!isVisible(parent, toolTrigger)) {
            setTooltipVisible(false);
        } else {
            setTooltipVisible(true);
        }
    };

    useEffect(() => {
        if (isOpen) {
            document.addEventListener('scroll', setPosition, true);
            setPosition();
        } else {
            setTooltipVisible(false);
        }

        return () => {
            document.removeEventListener('scroll', setPosition)
        };
    }, [isOpen, windowDimensions, randomId, text]);

    if (isTouchAble) {
        return children;
    }


    return (
        <>
            {/*case 1: child is just plain text*/}
            {!children.type &&
                <div
                    aria-describedby={randomId}
                    className={styles.tooltipTrigger}
                    data-yuja-tooltip-trigger-id={randomId}
                    onMouseLeave={isTouchAble ? () => {} : (e) => onMouseEnter(e)}
                    onMouseEnter={isTouchAble ? () => {} : (e) => onMouseLeave(e)}
                    onClick={isTouchAble ? (e) => onMouseEnter(e): () => {}}
                    tabIndex={disabled ? undefined : 0}
                    onFocus={(e) => onMouseEnter(e)}
                    onBlur={(e) => onMouseLeave(e)}
                    {...props}
                >
                    {children}
                </div>
            }

            {/*case 2: complicated children*/}
            {!!children.type &&
                React.cloneElement(
                    children,
                    {
                        tabIndex: disabled ? undefined : 0,
                        ...children.props,
                        "aria-describedby": randomId,
                        "data-yuja-tooltip-trigger-id": `${randomId}`,
                        onMouseEnter:  isTouchAble ? () => {} : (e) => onMouseEnter(e, children.props.onMouseEnter),
                        onMouseLeave: isTouchAble ? () => {} : (e) => onMouseLeave(e, children.props.onMouseLeave),
                        onClick: isTouchAble ? (e) => onMouseEnter(e, children.props.onClick): children.props.onClick,
                        onFocus: (e) => {
                            onMouseEnter(e, children.props.onMouseEnter);
                            if (!!children.props.onFocus) {
                                children.props.onFocus(e);
                            }
                        },
                        onBlur:  (e) => {
                            onMouseLeave(e, children.props.onMouseLeave);
                            if (!!children.props.onBlur) {
                                children.props.onBlur(e);
                            }
                        }
                    }
                )
            }

            {isOpen &&
                <>
                    <div
                        id={randomId}
                        role={"tooltip"}
                        data-yuja-tooltip-box-id={randomId}
                        className={`${styles.tooltip}`}
                        style={{...tooltipStyle, visibility: tooltipVisible && !disabled ? "visible" : "hidden"}}
                        onMouseLeave={(e) => onMouseLeave(e)}
                    >
                        {prohibit
                            ?
                            <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                <Prohibit style={{width: "25px", height: "25px", marginRight: "5px"}}/>
                                {text}
                            </div>
                            : text
                        }
                    </div>
                    <div
                        data-yuja-tooltip-triangle-id={randomId}
                        className={`${styles[placementVarRef.current]}`}
                        style={{visibility: tooltipVisible && !disabled ? "visible" : "hidden"}}
                    />
                </>
            }


            {/*{!isTouchAble &&*/}
            {/*    <TooltipWrapper>*/}
            {/*        <div*/}
            {/*            ref={tooltipRef}*/}
            {/*            className={`${styles.tooltip}`}*/}
            {/*            style={tooltipStyle}*/}
            {/*            onMouseLeave={(e) => onMouseLeave(e)}*/}
            {/*        >*/}
            {/*            {prohibit ? <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>*/}
            {/*                    <Prohibit style={{width: "25px", height: "25px", marginRight: "5px"}}/>*/}
            {/*                    {text}*/}
            {/*                </div> :*/}
            {/*                text*/}
            {/*            }*/}
            {/*        </div>*/}
            {/*        <div ref={tooltipTriangleRef} className={`${styles[placementVar]}`}/>*/}
            {/*    </TooltipWrapper>*/}
            {/*}*/}

            {/*{isTouchAble &&*/}
            {/*    <>*/}
            {/*        <TooltipWrapper>*/}
            {/*            <div*/}
            {/*                ref={tooltipRef}*/}
            {/*                className={`${styles.tooltip} ${visibleInTouchableDevice ? styles.visibleInTouchableDevice : ""}`}*/}
            {/*                style={tooltipStyle}*/}
            {/*            >*/}
            {/*                {prohibit ? <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>*/}
            {/*                    <Prohibit style={{ width: "25px", height: "25px", marginRight: "5px" }} />*/}
            {/*                    {text}*/}
            {/*                </div> :*/}
            {/*                    text*/}
            {/*                }*/}
            {/*            </div>*/}
            {/*            <div ref={tooltipTriangleRef} className={`${styles[placementVar]}  ${visibleInTouchableDevice ? styles.visibleInTouchableDevice : ""}`}/>*/}
            {/*        </TooltipWrapper>*/}
            {/*        {maskVisible &&*/}
            {/*            <div style={{position: "fixed", height: '100vh', width: '100vw', top: 0, left: 0, zIndex: 1000}} onTouchStart={onMouseLeave}/>*/}
            {/*        }*/}

            {/*    </>*/}
            {/*}*/}
        </>

    )
}

YuJaTooltip.propTypes = {
    text: PropTypes.any,
    placement: PropTypes.oneOf(["top", "bottom", "left", "right"]),
}